import { render, staticRenderFns } from "./ChapterCitations.vue?vue&type=template&id=df017c00&"
import script from "./ChapterCitations.vue?vue&type=script&lang=js&"
export * from "./ChapterCitations.vue?vue&type=script&lang=js&"
import style0 from "./ChapterCitations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports